<template>
  <div class="sellerPortal">
    <CustomizeHeader :goBack="false" right v-if="!headerExcludeList.includes($route.name)">
      <template slot="left">
        <!-- <v-img width="100" src="/img/logo.png" class="pointer no-background mr-2" @click="$router.push('/portal')"></v-img>
        主播中心 -->
        <div class="pointer d-flex align-center ml-4" @click="$router.push('/portal/profit')">
          <div class="peach"></div>
          <span class="pink--text">{{ seller.peach_wallet }}</span>
        </div>
      </template>
      <template slot="right">
        <v-menu open-on-hover bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              v-bind="attrs"
              v-on="on"
              depressed 
              class="seller transparent"
            >
              <v-avatar size="30" class="mr-2">
                <v-img :src="seller.usericon ? $HOST_URL + seller.usericon : ''"></v-img>
              </v-avatar>
              <div class="text-ellipsis">{{ seller.nickname }}</div>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item link @click="logout">
              <v-list-item-title>
                <v-icon left>logout</v-icon>
                登出
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex align-center" v-bind="attrs" v-on="on">
              <v-btn icon>
                <v-icon>fa-bell</v-icon>
              </v-btn>
            </div>
          </template>
        </v-menu>
      </template>
    </CustomizeHeader>
    <router-view></router-view>
    <NavigationBar v-if="!footerExcludeList.includes($route.name)"></NavigationBar>
  </div>    
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CustomizeHeader from '@/components/CustomizeHeader'
import NavigationBar from '@/components/portal/NavigationBar'
export default {
  components: { CustomizeHeader, NavigationBar },
  data() {
    return {
      headerExcludeList: ['Portal_Chatroom'],
      footerExcludeList: ['Portal_Chatroom']
    }
  },
  computed: {
    ...mapState('seller', ['seller'])
  },
  created() {
    this.$store.dispatch('seller/getSellerInformation')
    this.$store.dispatch('seller/getBlockList')
  },
  methods: {
    logout() {
      this.axios.post('/portal/logout').then(response => {
        this.$store.dispatch('seller/logout')
        this.$router.push('/login?type=seller')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.sellerPortal {
  background: #f6f6f6;
  min-height: 100%;
  color: black;
  .seller {
    display: flex;
    align-items: center;
    border-radius: 20px;
    font-size: 14px;
    text-transform: none;
    font-weight: 300;
    max-width: 200px;
    padding: 0 8px !important;
    .v-btn__content {
      max-width: 100%;
      letter-spacing: 0;
    }
  }
  .table-header {
    color: #999999;
    background-color: #f6f6f6;
  }
  .table-content {
    position: relative;
    justify-content: space-between;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.03);
    }
    &.shrink {
      .col {
        width: unset;
        flex-basis: auto;
        flex-grow: 1;
      }
    }
  }
  .table-header, .table-content {
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 300;
    text-align: center;
    align-items: center;
    min-width: 100%;
    margin: unset;
    @include mobile {
      padding: 8px 0 !important;
    }
    .col {
      @extend .text-ellipsis;
      white-space: nowrap;
      padding: 4px 12px;
      &:first-child {
        padding-left: 4px;
        display: flex;
        align-items: center;
        text-align: left;
        justify-content: flex-start;
      }
      &:last-child {
        padding-right: 4px;
        text-align: end;
      }
      .description {
        @extend .text-ellipsis;
      }
    }
  }
  .wrapper {
    background: white;
    padding: 16px 24px;
    margin-bottom: 28px;
    @include mobile {
      padding: 16px 12px
    }
  }
}
</style>